import axios from '@dap/shared-utils/http.js';

export default {
    // 获取公用字典
    getFinanceDict () {
        return axios.get('/dapper/api/finance-v2/dict');
    },

    // 编辑页面, 根据类型获取名称
    getTierList (tierName, params = {}) {
        return axios.get(`/dapper/api/finance/v3/cost_name_${tierName}`, {
            params,
        });
    },

    // 获取region字典
    getRegionDict (params = {}) {
        return axios.get('/dapper/api/insights/my_insight/region_dict', {
            params,
        });
    },

    // 消耗列表页
    getCostInTableList (params = {}) {
        return axios.get('/dapper/api/finance-v2/cost-list', { params });
    },

    // 消耗录入根据营销类型拿到合作代理
    getMKTMaster (params) {
        return axios.get('/dapper/api/finance-v2/branding-masters', { params });
    },

    getMasterBySpreader (params) {
        return axios.get('/dapper/api/finance/v3/master_by_spreader', {
            params,
        });
    },
    getCountry () {
        return axios.get('/dapper/api/finance/v3/country_shortcuts');
    },

    // 选择的渠道是否为海外网盟
    getSpreaderIsNetwork (params) {
        return axios.get('/dapper/api/finance/v3/spreaders', { params });
    },

    // 获取临时新建广告的各种name
    getNamePreview (params) {
        return axios.get('/dapper/api/finance-v2/branding-levels-preview', {
            params,
        });
    },

    // 消耗录入预览
    previewList (params = {}) {
        return axios.get('/dapper/api/finance-v2/cost-preview', { params });
    },

    // 消耗录入详情
    getCostInDetail (params = {}) {
        return axios.get('/dapper/api/finance-v2/cost-detail', { params });
    },

    // 消耗录入预提交
    postCostInSingle (params = {}) {
        return axios.post('/dapper/api/finance-v2/cost-single', params);
    },

    // 消耗录入确认提交
    confirmCostInSingle (params = {}) {
        return axios.post('/dapper/api/finance-v2/cost-commit', params);
    },

    // 消耗编辑
    editCostIn (params = {}) {
        return axios.post('/dapper/api/finance-v2/cost-edit', params);
    },

    // 消耗批量删除
    delCostIn (params = {}) {
        return axios.post('/dapper/api/finance-v2/cost-batch-delete', params);
    },

    // 消耗日志
    getCostInLog (params = {}) {
        return axios.get('/dapper/api/finance-v2/cost-log', { params });
    },

    // cpa列表
    getCPAInTableList (params = {}) {
        return axios.get('/dapper/api/finance-v2/cpa-list', { params });
    },

    // 获取相关商主/广告计划/广告组/广告
    getCPAInRelative (params = {}) {
        return axios.get('/dapper/api/finance-v2/cost_level_data', { params });
    },

    // 开启状态修改
    changeCPAStatus (params = {}) {
        return axios.get('/dapper/api/finance-v2/cpa-status', { params });
    },

    // cpa明细
    getCPADetail (params = {}) {
        return axios.get('/dapper/api/finance-v2/cpa-detail', { params });
    },

    // cpa新增/编辑
    putCPAIn (params = {}) {
        return axios.post('/dapper/api/finance-v2/cpa-save', params);
    },

    // cpa执行日志
    getCPAExeLog (params = {}) {
        return axios.get('/dapper/api/finance-v2/cpa-exec-log', { params });
    },

    // cpa操作日志
    getCPALog (params = {}) {
        return axios.get('/dapper/api/finance-v2/cpa-opt-log', { params });
    },

    // cpa获取分包
    getCPAPackageList (params = {}) {
        return axios.get('/dapper/api/finance-v2/level_app', { params });
    },

    // 消耗录入轮询
    pollCostIn: (params) => axios.get('/dapper/api/finance-v2/cost_calc_status', { params }),
    // 代理商游戏列表
    getAgentGames: (params) => axios.get('/dapper/api/finance-v2/agent-games', { params }),
};
